import React, { useState, useEffect } from "react";
import {
  Box,
  Card,
  Grid2,
  Stack,
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  CircularProgress,
  Alert,
} from "@mui/material";
import CustomStepper from "../../../component/common/Stepper";
import PersonalDetails from "../steps/personal-details";
import DeviceDetails from "../steps/device-details";
import RecieptDetails from "../steps/reciept-details";
import { useForm } from "react-hook-form";
import axios from "axios";
import MuiButton from "../../../component/common/MuiButton";
import { useSnackbar } from "../../../component/common/Snackbar";
import { useNavigate, useSearchParams } from "react-router";
import ReCAPTCHA from "react-google-recaptcha";
export default function RightSection() {
  const API_ENDPOINT = process.env.REACT_APP_API_URL;
  const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
  const navigate = useNavigate();
  const [SnackbarComponent, showSnackbar] = useSnackbar();
  const { control, handleSubmit, reset, watch, setValue } = useForm();
  const [activeStep, setActiveStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [captchaOpen, setCaptchaOpen] = useState(false);
  const [captchaToken, setCaptchaToken] = useState(null);
  // console.log("recaptcha site key = ", RECAPTCHA_SITE_KEY);
  const [searchParams] = useSearchParams();
  const userParam = searchParams.get("user");
  const doctorParam = searchParams.get("doctor");
  // console.log("watch = ", watch());
  const steps =
    userParam && doctorParam
      ? ["Personal Info", "Program Details"] // skip receipt
      : ["Personal Info", "Program Details", "Receipt Details"];
  const handleNext = () => {
    setActiveStep((prevStep) => prevStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevStep) => prevStep - 1);
  };
  const stepForms =
    userParam && doctorParam
      ? [
          <PersonalDetails control={control} watch={watch} />,
          <DeviceDetails control={control} watch={watch} />,
        ]
      : [
          <PersonalDetails control={control} watch={watch} />,
          <DeviceDetails control={control} watch={watch} />,
          <RecieptDetails control={control} />,
        ];
  const handleCaptchaChange = (token) => {
    setCaptchaToken(token);
  };
  // console.log("watch = ", watch());
  const handleFinalSubmit = async (formData) => {
    if (!captchaToken) {
      showSnackbar("Please complete the captcha", "error");
      return;
    }
    if (formData.reasonForUsing !== "Other") {
      delete formData.otherReasonForUsingEkko;
    }
    const data = {
      ...formData,
      city: formData.city.id,
      assignedTo: doctorParam ? formData.assignedTo : formData.assignedTo.id,
      email: formData?.email?.toLowerCase(),
      isDoctorSubmission: !!userParam, // ⬅️ true if clinician filled
      doctorUserId: userParam || null, // 👈 track who submitted
      recaptchaToken: captchaToken, // send token to backend for verification
    };
    // console.log("data = ", data);
    setCaptchaOpen(false);
    setLoading(true);
    try {
      await axios.postForm(`${API_ENDPOINT}/submit_form`, data);
      reset();
      setActiveStep(0);
      navigate("/successful-submission");
    } catch (err) {
      setError(
        err?.response?.data?.message ||
          err?.message ||
          "Oops! Something went wrong",
      );
      // showSnackbar(
      //   err?.response?.data?.message ||
      //     err?.message ||
      //     "Oops! Something went wrong",
      //   "error"
      // );
    } finally {
      setLoading(false);
      setCaptchaOpen(false);
      setCaptchaToken(null);
    }
  };
  //console.log("recaptcha site key" ,RECAPTCHA_SITE_KEY)
  const onSubmit = async (data) => {
    if (activeStep === steps.length - 1) {
      // data.city = data.city.id;
      // data.assignedTo = data.assignedTo.id;
      // data.email = data.email.toLowerCase();
      setError(null);
      setCaptchaOpen(true); // show captcha dialog
      // setLoading(true);
      // axios
      //   .postForm(`${API_ENDPOINT}/submit_form`, data)
      //   .then((res) => {
      //     // showSnackbar(
      //     //   res?.data?.message || "Form submitted successfully!",
      //     //   "success"
      //     // );
      //     reset();
      //     setActiveStep(0);
      //     navigate("/successful-submission");
      //   })
      //   .catch((err) => {
      //     // console.log("error = ", err);
      //     showSnackbar(
      //       err?.response?.data?.message ||
      //         err?.message ||
      //         "Oops! Something went wrong",
      //       "error"
      //     );
      //   })
      //   .finally(() => {
      //     setLoading(false);
      //   });
    } else {
      handleNext();
    }
  };
  useEffect(() => {
    if (doctorParam && userParam) {
      setValue("assignedTo", doctorParam);
    }
  }, [doctorParam, userParam]);
  return (
    <Grid2
      size={{ xs: 12, md: 9 }}
      sx={{
        padding: { xs: "16px", md: 4 },
        display: "flex",
        flexDirection: "column",
        justifyContent: { xs: "start", md: "center" },
      }}
      component="form"
      onSubmit={handleSubmit(onSubmit)}
    >
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      <CustomStepper steps={steps} activeStep={activeStep} />
      <Card
        sx={{
          my: 4,
          padding: 4,
          minHeight: "320px", // Minimum height for consistency
          // maxHeight: "500px", // Minimum height for consistency
          // overflow: "auto",
        }}
      >
        <Grid2 container spacing={2}>
          {stepForms[activeStep]}
        </Grid2>
      </Card>

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <MuiButton onClick={handleBack} disabled={loading || activeStep === 0}>
          Back
        </MuiButton>
        <Stack direction="row" alignItems="center" gap={2}>
          {/* {activeStep === steps.length - 1 && (
            <ReCAPTCHA sitekey={RECAPTCHA_SITE_KEY} onChange={() => {}} />
          )} */}
          <MuiButton type="submit" loading={loading}>
            {activeStep === steps.length - 1 ? "Finish" : "Next"}
          </MuiButton>
        </Stack>
      </Box>
      <Dialog
        open={captchaOpen}
        // onClose={() => setCaptchaOpen(false)}
        PaperProps={{
          sx: {
            borderRadius: 3,
            p: 3,
            minWidth: 380,
          },
        }}
      >
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 3,
          }}
        >
          <Typography variant="h6" fontWeight="600">
            🛡️ Security Check
          </Typography>
          <Typography variant="body2" color="text.secondary" align="center">
            Please complete the captcha below to confirm your submission.
          </Typography>

          <ReCAPTCHA
            sitekey={RECAPTCHA_SITE_KEY}
            onChange={handleCaptchaChange}
          />
        </DialogContent>

        <DialogActions sx={{ justifyContent: "space-between", mt: 1 }}>
          <MuiButton
            variant="outlined"
            color="error"
            onClick={() => setCaptchaOpen(false)}
          >
            Cancel
          </MuiButton>
          <MuiButton
            onClick={handleSubmit(handleFinalSubmit)}
            disabled={!captchaToken || loading}
            // loading={loading}
          >
            Submit
          </MuiButton>
        </DialogActions>
      </Dialog>

      {/* Add the SnackbarComponent */}
      <SnackbarComponent />
    </Grid2>
  );
}
